import {i18n} from "@kopjra/uikit";
import {WSS_ENDPOINT} from "./constants.ts";

export type ConnectivityCheckResult = {
    status: "OK" | "KO";
    reason?: string;
};

export async function verifyConnectivity(timeoutMs: number = 2000): Promise<ConnectivityCheckResult> {
    return new Promise((resolve) => {
        // Check if WebSocket is supported by the browser
        if (!("WebSocket" in window)) {
            resolve({ status: "KO", reason: i18n.t("new.wssFailedToConnect") });
            return;
        }

        let ws: WebSocket | null = null;
        let didConnect = false;

        // Create WebSocket connection
        try {
            ws = new WebSocket(WSS_ENDPOINT);
        } catch (err) {
            console.log("Failed to create WebSocket:", err);
            resolve({ status: "KO", reason: i18n.t("new.wssFailedToConnect") });
            return;
        }

        // Setup timer to fail if connection takes too long
        const timeout = setTimeout(() => {
            if (!didConnect) {
                ws?.close();
                console.log("WebSocket connection timed out");
                resolve({ status: "KO", reason: i18n.t("new.wssFailedToConnect") });
            }
        }, timeoutMs);

        // On successful connection
        ws.onopen = () => {
            didConnect = true;
            clearTimeout(timeout);
            ws?.close();
            resolve({ status: "OK" });
        };

        // On error during connection
        ws.onerror = (event) => {
            clearTimeout(timeout);
            console.log("WebSocket error:", event);
            resolve({ status: "KO", reason: i18n.t("new.wssFailedToConnect") });
        };

        // On unexpected close before open
        ws.onclose = () => {
            if (!didConnect) {
                clearTimeout(timeout);
                console.log(`WebSocket connection timed out before it should have`);
                resolve({ status: "KO", reason: i18n.t("new.wssFailedToConnect") });
            }
        };
    });
}
